export function getPayloadErrorMessage(payload: any, fallbackMessage: string): string | null {
    if (!payload || payload.success !== false) {
        return null;
    }

    if (Array.isArray(payload.errors)) {
        const firstError = payload.errors.find((error: any) => error && error.message);
        if (firstError && firstError.message) {
            return firstError.message;
        }
    }

    return payload.error || fallbackMessage;
}

export function getRelayFailureMessage(error: any, fallbackMessage: string): string {
    if (error && typeof error.getError === 'function') {
        const relayError = error.getError();
        if (relayError && relayError.message) {
            return relayError.message;
        }
    }

    return (error && error.message) || fallbackMessage;
}
